import { useState, useEffect } from "react";
import "./css/Modal.css";
import { FaTimesCircle, FaWindowClose } from "react-icons/fa";
import {API_BASE_URL, BookingAddAPIEndpoint, ResidentGetAPIEndpoint} from "../constant.js"
import Select from "react-select";

const BookingForm = ({ openBooking, area, onBookingClose, allFlats}) => {
  const token = sessionStorage.getItem("JWTtoken");
  const userId = sessionStorage.getItem("userId"); // or session
  const userType = sessionStorage.getItem("userType"); // or session
  //const [flatNumbers, setFlatNumbers] = useState([]);

  //setFlatNumbers(allFlats);
  //console.log(JSON.stringify(allFlats));
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");

  const [form, setForm] = useState({
    name: "",
    description: "",
    capacity: "",
    charge: "",
    status: "active",
    
  });


  

  useEffect(() => {
    if (area) {
      setForm(area); // pre-fill form
    }
    //GetFlatNumbers();
  }, [area]);

 /* const GetFlatNumbers = async(e) =>{
    if(userType === "admin")
    {
      
    try{
    const apiURL = API_BASE_URL + ResidentGetAPIEndpoint;
    const response = fetch(apiURL);
    const res = response.json();
    alert(JSON.stringify(res));
    if (res.status) {
      const options = res.data.map(item => ({
        value: item.id,
        label: item.apartment
      }));
      setFlatNumbers(options); 
    }}    catch(err){
      setFlatNumbers([]);
    }
    }
  }*/

  if (!openBooking) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

   const validate = () => {


    const selectedDate = new Date(form.startDateTime); // "2025-12-25"   
    const now = new Date();
    if (selectedDate < now) {
      alert("Selected date must be greater than current date & time");
      return; 
    }

    

    if (new Date(form.endDateTime) <= new Date(form.startDateTime)) {
      alert("End time must be greater than start time");
      return;
    }

     if (!form.name.trim() || !form.commonareadesc.trim() || !form.charge.trim() || !form.capacity.trim()) {
      alert("Name, Description, Charge and Capacity are required!");
      return; 
    }

    if (Number(form.charge) <= 0 || Number(form.capacity) <= 0) {
      alert("Charge and Capacity must be greater than zero!");
      return; 
    }

    return true;

   }

  const handleSubmit = async(e) => {
    //alert("MANJIT Before\n" + JSON.stringify(form));
    e.preventDefault();
    //onUpdate(form); // send updated data

    

    if (!validate()) return;

    try {
        const bookingAPIURL = API_BASE_URL + BookingAddAPIEndpoint;
        const payload = {
          ...form,  // existing form fields
          "status": "pending",
           "resident_id": userType === "admin" ? form.flat.value : userId

         /* "amount": area.charge,
          "approved_by":"",
          "id":form.id,
          "status": "pending",
          "resident_id": apartment,
          "fromTime":area.fromTime,
          "toTime":area.toTime,
          "purpose":area.purpose*/
        };




        //alert("MANJIT After \n" + JSON.stringify(payload));

    const response = await fetch(bookingAPIURL,
      {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
         },
        body: JSON.stringify(payload)
      }
    );

    const result = await response.json();
    if (result.status) {
      alert("Common-area booking successfully.");
      setForm({
        name: "",
        description: "",
        capacity: "",
        charge: "",
        status: "active",
        purpose:"",
        
      });
    } else {
      alert(result.message);
    }



  } catch (err) {
    alert("Server error");
  }
    onBookingClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Booking {form.name} <div style={{ float : "right" }} > <FaWindowClose className="edit-icon"  onClick={onBookingClose} /> </div>  </h3>

         <form onSubmit={handleSubmit}>
         {
         userType == "admin" && <div> Flat No
          <Select
            options={allFlats}
            value={form.flat}
            onChange={(val) => setForm({ ...form, flat: val })}
            placeholder="Search flat..."
            className="select-box"
          /> </div>
         } 
        Start DateTime
        {/*<input
                type="date"
                name="bookingDate"
                value={form.date}
                onChange={handleChange}
                required
        />*/}
         <input
            type="datetime-local"
            name="bookingStartDate"
            value={form.startDateTime}
            onChange={handleChange}
             min={new Date().toISOString().slice(0,16)}
          />
        End DateTime
        { /*<input
                type="date"
                name="bookingEndDate"
                value={form.enddate}
                onChange={handleChange}
                required
        />*/}
         <input
            type="datetime-local"
            name="bookingEndDate"
            value={form.endDateTime}
            onChange={handleChange}
             min={new Date().toISOString().slice(0,16)}
          />
        Purpose
        <input
                type="text"
                name="purpose"
                value={form.purpose}
                onChange={handleChange}
                placeholder="Birthday, Meeting..."
                required
        />
        {/*From Time
         <input
                type="time"
                name="fromTime"
                value={form.fromTime}
                onChange={handleChange}
                required
          />
         To Time
         <input
                type="time"
                name="toTime"
                value={form.toTime}
                onChange={handleChange}
                required
          /> */}
          <div className="actions">
            <button type="submit" className="btn-primary">
              Confirm Booking
            </button>
            <button type="button" className="btn-secondary" onClick={onBookingClose}>
              Cancel
            </button>
          </div>
      </form>
      </div>
    </div>
  );
};

export default BookingForm;





/*import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import "./css/commonareas.css";
import { FaTimesCircle, FaWindowClose } from "react-icons/fa";

const BookingForm = ({ openBooking, area, onBookingClose, onOpen }) => {
  // const [form, setForm] = useState({
  //   date: "",
  //   fromTime: "",
  //   toTime: "",
  //   purpose: ""
  // });

  const [form, setForm] = useState({
    name: "",
    description: "",
    capacity: "",
    charge: "",
    status: "active"
  });



  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //onSubmit({ ...form, areaId: area.id });
  };

onBookingClose();

return(
  <div className="modal-overlay">
    <div className="modal">
      <h3>Booking Common Area <div style={{ float : "right" }} > <FaWindowClose className="edit-icon"  onClick={onBookingClose} /> </div>  </h3>

      <form onSubmit={handleSubmit}>
        Date
        <input
                type="date"
                name="date"
                value={form.date}
                onChange={handleChange}
                required
        />
        Purpose
        <input
                type="text"
                name="purpose"
                value={form.purpose}
                onChange={handleChange}
                placeholder="Birthday, Meeting..."
                required
        />
        From Time
         <input
                type="time"
                name="fromTime"
                value={form.fromTime}
                onChange={handleChange}
                required
          />
         To Time
         <input
                type="time"
                name="toTime"
                value={form.toTime}
                onChange={handleChange}
                required
          /> 
          <div className="actions">
            <button type="submit" className="btn-primary">
              Confirm Booking
            </button>
            <button type="button" className="btn-secondary" onClick={onBookingClose}>
              Cancel
            </button>
          </div>
      </form>
    </div>
  </div>
      

);



/*
  return (
    <div className="booking-overlay">
      <div className="booking-card">
        <FaTimes className="close-icon" onClick={onClose} />

        <h3>Book {area.name}</h3>

        <form onSubmit={handleSubmit}>
          <div className="row">
            <div>
              <label>Date</label>
              <input
                type="date"
                name="date"
                value={form.date}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>Purpose</label>
              <input
                type="text"
                name="purpose"
                value={form.purpose}
                onChange={handleChange}
                placeholder="Birthday, Meeting..."
                required
              />
            </div>
          </div>

          <div className="row">
            <div>
              <label>From Time</label>
              <input
                type="time"
                name="fromTime"
                value={form.fromTime}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>To Time</label>
              <input
                type="time"
                name="toTime"
                value={form.toTime}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="info-box">
            <p>
              <strong>Charge:</strong> ₹{area.charge}
            </p>
            <p>
              <strong>Capacity:</strong> {area.capacity} persons
            </p>
          </div>

          <div className="actions">
            <button type="submit" className="btn-primary">
              Confirm Booking
            </button>
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BookingForm;
*/